import { Link } from 'react-router-dom';
import { usePageMetadata } from '../hooks/usePageMetadata';

export function NotFound() {
  usePageMetadata({
    title: 'Page Not Found — PhotoFeeler AI',
    description: 'The page you were looking for doesn\'t exist.',
    canonicalPath: '/',
  });

  return (
    <div className="pt-28 pb-16 text-center max-w-4xl mx-auto px-5 sm:px-8 animate-fade-in">
      <h1 className="font-sans text-6xl text-ink mb-4" style={{ fontWeight: 700 }}>404</h1>
      <h2 className="font-sans text-2xl text-ink mb-3" style={{ fontWeight: 500 }}>
        Page not found
      </h2>
      <p className="text-sm text-ink-faint mb-8" style={{ fontWeight: 300 }}>
        The page you were looking for doesn&apos;t exist. It may have been moved or removed.
      </p>
      <div className="flex justify-center gap-3">
        <Link to="/" className="btn-primary text-xs">Back to home</Link>
        <Link to="/dating" className="btn-secondary text-xs">Dating photos</Link>
        <Link to="/linkedin" className="btn-secondary text-xs">LinkedIn photos</Link>
      </div>
    </div>
  );
}
